const loadProductIds = () =>
  window.App.shop ? {sortedItemIds: window.App.shop.showcase_item_ids} : {}

const initialState = {editProductId: null, sortedItemIds: [], newProduct: false}

const removeProduct = (state, id) => {
  const index = state.sortedItemIds.indexOf(id);
  return {...state,
    sortedItemIds: [
      ...state.sortedItemIds.slice(0, index),
      ...state.sortedItemIds.slice(index + 1, state.sortedItemIds.length)
    ]
  }
}

const loadNewProducts = (state, data) => {
  return {...state, sortedItemIds: data.showcase_item_ids}
}

const productList = (state = initialState, action) => {
  switch (action.type) {
    case "SHOP.INIT":
    case "SHOP_INVENTORY.INIT":
    case "PAYMENT_MODAL.INIT":
      return {...state, ...loadProductIds()}
    case "SHOP.NEW_PRODUCT":
      return {...state, newProduct: true}
    case "SHOP.EDIT_PRODUCT":
      return {...state, editProductId: action.payload.id}
    case "SHOP.CANCEL_PRODUCT_MODAL":
      return {...state, newProduct: false, editProductId: null}
    case "SHOP_PRODUCT_REMOVE_SUCCESS":
      return removeProduct(state, action.payload.id);
    case "SHOP_PRODUCTS_RECEIVED":
      return loadNewProducts(state, action.payload);
    default:
      return state
  }
}

export default productList;
